export const queryKeys = {
  dashboard: (days?: number, newsLimit?: number, faqLimit?: number) =>
    ['dashboard', days, newsLimit, faqLimit] as const,
  basicInfo: ['dashboard', 'basicInfo'] as const,
};
